import './polyfills';
import './i18n';
import React, { version as reactVersion } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/fip-theme.css';
import './styles/tournament.css';
import './styles/report-theme.css';
import './styles/matchlytics-theme.css';
import { REPORT_SKIN } from './lib/utils';

// On <html>, before the first render: the skin also reaches what renders outside
// the report's wrapper (splash, identification, bottom sheets).
if (REPORT_SKIN === 'matchlytics') {
  document.documentElement.classList.add('matchlytics-theme');
}

console.log('Main.tsx loaded');
console.log('React version:', reactVersion);

// React 18 supports createRoot and works with proper polyfills
const container = document.getElementById('root');
console.log('Root container:', container);

if (container) {
  try {
    console.log('Creating root...');
    const root = createRoot(container);
    console.log('Root created, rendering app...');
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
    console.log('App rendered successfully');
  } catch (error) {
    console.error('Error rendering app:', error);
  }
} else {
  console.error('Root container not found!');
}
